import { useState } from 'react';
import axios from 'axios';
import { useNavigate, Link } from 'react-router-dom';
import './LoginPage.css';  

export default function LoginPage() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post(
        'https://nagradjivanje-api.revicon.info/auth/login',
        { email, password },
        {
          withCredentials: true,
          headers: { 'Content-Type': 'application/json' }
        }
      );
      localStorage.setItem('token', res.data.token);
      navigate('/welcome');
    } catch (err) {
      alert('Neuspješna prijava. Provjerite podatke.');
      console.error('Login error:', err.response?.data || err.message);
    }
  };

  return (
    <div className="page-container">
      <div className="image-container"></div>
      <div className="form-container">
        <div className="login-card">
          <h2>Prijava na NEXUS</h2>
           <p>Dobrodošli nazad! Unesite Vaše podatke za prijavu.</p>
          <form onSubmit={handleLogin}>
            <label>Email</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <label>Lozinka</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit">Prijavi se</button>
          </form>
          <p>
            Nemate nalog? <Link to="/register">Registruj se</Link>
          </p>
        </div>
      </div>
    </div>
  );
}
